import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from "rxjs";
import { Storage } from '@ionic/storage';

/*
  Generated class for the BaseService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BaseService {

  constructor(
    public http: Http,
    protected storage: Storage
  ) {
    storage.ready().then(() => {
      console.log('Storage initialized');
    })
      .catch((err) => {
        console.log(err);
      })
    ;
  }

  protected getStorageItem(key: string): Promise<any>{
    return new Promise((resolve, reject) => {
      this.storage.get(key)
        .then(d => {
          return resolve(d);
        })
        .catch(e => {
          return reject(e);
        });
    });
  }

  protected getToken(): Promise<string>{
    return this.getStorageItem('access-token');
  }

  protected get accessToken(){
    return(async () => await this.getToken());
  }

  protected get token(): string{
    return window.localStorage.getItem('access-token');
  }

  protected set token(t: string){
    window.localStorage.setItem('access-token', t);

    // this.storage.set('access-token', t)
    //   .then(token => {
    //   })
    //   .catch(e => {
    //     console.log("Cannot set token:");
    //     console.log(e);
    //   });
  }

  protected get userName(): string{
    return window.localStorage.getItem('access-login');
  }

  protected set userName(n: string){
    window.localStorage.setItem('access-login', n);

    this.storage.set('access-login', n)
      .then(un => {
      })
      .catch(e => {
        console.log("Cannot set user name:");
        console.log(e);
      });
  }

  protected getAsyncHeaders(): Promise<Headers>{
    return new Promise<Headers>((resolve, reject) => {
      this.getToken().then(
        t => {
          let headers = new Headers();
          headers.append('Content-Type', 'application/json');
          headers.append('Access-Control-Allow-Origin', '*');
          headers.append('Authorization', "Bearer " + t);

          return resolve(headers);
        }
      )
        .catch(err => {
          return reject(err);
        })
    });
  }

  // AS: подготовка заголовков к запросу. Включаем cross origin и токен авторизации
  protected get headers(): any{
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', "Bearer " + this.token);

    return headers;
  }

  protected get loginHeaders(): any{
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');

    return headers;
  }

  protected handleError (error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error._body ? JSON.parse(error._body) :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

  protected logError(error: any){
    let errMsg = (error.message) ? error.message :
      error._body ? JSON.parse(error._body) :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
  }

  protected prepareData(res: Response): any{
    let body = res.json();
    var d = body || {};
    return d;
  }
}



// WEBPACK FOOTER //
// ./src/providers/base-service.ts